<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("processmente.title_edit") }}</h1>
    <form>
      <!-- 編集 -->
      <b-card :title="this.$i18n.t('processmente.label_edit')" class="w-50">
            <b-form-group
              id="processId"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('processmente.label_process_id')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="processId" disabled=true :placeholder="this.$i18n.t('processmente.placeholder_process_id')" maxlength="4"></b-form-input>
            </b-form-group>
            <b-form-group
              id="processName"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('processmente.label_process_name_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="processName" :placeholder="this.$i18n.t('processmente.placeholder_process_name')" maxlength="40"></b-form-input>
            </b-form-group>
            <b-form-group
              id="processTypeList"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('processmente.label_process_type')"
              label-for="input-horizontal"
            >
              <b-form-select v-model="processTypeList" disabled=true :options="options" class="mb-3" ></b-form-select>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="back" class="float-left px-5">{{ $i18n.t("processmente.label_back") }}</b-button>
            </div>
            <div>
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("processmente.button_update") }}</b-button>
            </div>
      </b-card>
    </form>
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('processmente.info_update')" :titleMsg="this.$i18n.t('processmente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirmModal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      processId: null,
      processName: null,
      processTypeList: null,
      searchProcessId: null,
      searchProcessName: null,
      searchProcessTypeId: null,
      efFlg: true,
      currentPage: 1,
      perPage: 5,
      options: [
        { value: '1', text: this.$i18n.t('processmente.label_test_process') },
        { value: '2', text: this.$i18n.t('processmente.label_pass_process') }
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      errMsg: '',
      errSbj: ''
    }
  },
  methods: {
    regist: function () {
      // 入力値チェック
      if (this.processName === null || this.processName === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('processmente.err_process_name_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.processName)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('processmente.err_process_name_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (this.processTypeList === null || this.processTypeList === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('processmente.err_process_type_hissu')
        this.$bvModal.show('md-err')
        return
      }

      // リクエスト
      var reqObj = {}
      reqObj.processId = String(this.processId)
      reqObj.processName = this.processName
      reqObj.processType = this.processTypeList

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/process/update', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    registConfirm: function () {
      this.$bvModal.hide('md-confirm')
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    },
    back: function () {
      var searchFlg = 1
      var path = '/processmente'
      this.$router.push({ path: path, query: {searchFlg: [searchFlg], searchProcessId: [this.searchProcessId], searchProcessName: [this.searchProcessName], searchProcessTypeId: [this.searchProcessTypeId]} })
    }
  },
  created () {
    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    var body = {}
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/common/checkLogin', body, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        }
      })
      .catch(res => {
        // とりあえずログイン画面へ飛ばす
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        this.$router.push('/')
      })

    // 値セット
    this.processId = this.$store.store.state.processId
    this.processName = this.$store.store.state.processName
    this.processTypeList = this.$store.store.state.processType
    console.log(this.from)

    // 検索条件セット
    this.searchProcessId = this.$store.store.state.searchProcessId
    this.searchProcessName = this.$store.store.state.searchProcessName
    this.searchProcessTypeId = this.$store.store.state.searchProcessTypeId
  },
  routes: [
    {
      path: '/processmente/:searchFlg/:searchProcessId/:searchProcessName/:searchProcessTypeId',
      name: 'processmente',
      components: './Processmente.vue'
    }
  ]
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProcessmenteEdit.vue